import { CoordinatesModel } from '@marketplace-web/shipping/checkout-shipping-data'

export const transformGoogleLatLngCoordinates = ({ latitude, longitude }: CoordinatesModel) =>
  new window.google.maps.LatLng(latitude, longitude)
